import { ReadonlyURLSearchParams } from 'next/navigation';
import type { ConfigOrigins } from '@/lib/config-origin/domain';
import { orderOrBasketToReturnParams } from '@/lib/order/basket/app/orderOrBasketToReturnParams';
import { paramsToPersistForConfig, paramsToPersistsForSEAC } from '@/utils/param-persistence/searchParamsToPersistInFlow';

export const CONFIG_ORIGIN_PARAM_KEY = 'config-origin';
export const CONFIG_ORIGINS: ConfigOrigins = {
	configurator: {
		key: 'configurator',
		default: {
			queryStringGenerator: (basketOrOrder, selectedVehicle, queryString, protectedValues) => {
				return `${[
					basketOrOrder && selectedVehicle
						? orderOrBasketToReturnParams('configurator', basketOrOrder, selectedVehicle, protectedValues)
						: '',
					paramsToPersistForConfig(new ReadonlyURLSearchParams(queryString))
				]
					.filter((x) => !!x)
					.join('&')}`;
			},
			redirectPath: 'configurator'
		},
		finance: {
			queryStringGenerator: (basketOrOrder, selectedVehicle, queryString, protectedValues) => {
				return `${[
					basketOrOrder && selectedVehicle
						? orderOrBasketToReturnParams('configurator', basketOrOrder, selectedVehicle, protectedValues)
						: '',
					paramsToPersistForConfig(new ReadonlyURLSearchParams(queryString))
				]
					.filter((x) => !!x)
					.join('&')}`;
			},
			redirectPath: 'configurator'
		}
	},
	seac: {
		key: 'seac',
		default: {
			queryStringGenerator: (basketOrOrder, selectedVehicle, queryString, protectedValues) => {
				return `${[
					basketOrOrder && selectedVehicle
						? orderOrBasketToReturnParams('seac', basketOrOrder, selectedVehicle, protectedValues)
						: '',
					paramsToPersistsForSEAC(new ReadonlyURLSearchParams(queryString))
				]
					.filter((x) => !!x)
					.join('&')}`;
			},
			redirectPath: 'see-earlier-available-cars/vehicle'
		},
		finance: {
			queryStringGenerator: (basketOrOrder, selectedVehicle, queryString, protectedValues) => {
				return `${[
					basketOrOrder && selectedVehicle
						? orderOrBasketToReturnParams('seac', basketOrOrder, selectedVehicle, protectedValues)
						: '',
					paramsToPersistsForSEAC(new ReadonlyURLSearchParams(queryString))
				]
					.filter((x) => !!x)
					.join('&')}`;
			},
			redirectPath: 'see-earlier-available-cars/vehicle'
		}
	}
} as const;
